const Logo = () => {
    return <h1>✈️ Destination Diary 📓</h1>
}

export default Logo;